import { openDB, promisifyRequest } from '../database/db';
import { auditLogger } from '../audit/auditLogger';
import { dateUtils } from '../utils/dateUtils';

export const backupEngine = {
  // ساخت پکیج خروجی کامل برای پروژه
  exportProjectPackage: async (projectId) => {
    const db = await openDB();
    
    // ۱. دریافت متادیتای پروژه
    const projectTx = db.transaction('projects', 'readonly');
    const project = await promisifyRequest(projectTx.objectStore('projects').get(projectId));
    if (!project) throw new Error('پروژه مورد نظر یافت نشد.');

    // ۲. دریافت تمامی رکوردهای مهندسی
    const recordTx = db.transaction('records', 'readonly');
    const recordIndex = recordTx.objectStore('records').index('projectId');
    const records = await promisifyRequest(recordIndex.getAll(projectId));

    // ۳. دریافت لاگ‌های حسابرسی
    const auditLogs = await auditLogger.getByProject(projectId);

    // پکیج نهایی استاندارد مهندسی
    const exportData = {
      format: 'CIVIL_NEXUS_EXPORT',
      schemaVersion: 3,
      exportedAt: dateUtils.now(),
      project,
      records: records || [],
      auditTrail: auditLogs || []
    };

    // ایجاد فایل دانلودی JSON
    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const safeTitle = (project.metadata?.title || 'project').replace(/[\/\\]/g, '-');
    link.href = url;
    link.download = `CivilNexus_${safeTitle}_${dateUtils.formatJalali(dateUtils.now()).replace(/\//g, '-')}.cnex.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    // ثبت در لاگ
    await auditLogger.log(projectId, 'EXPORT', 'project', projectId, {
      recordsCount: records.length,
      auditCount: auditLogs.length
    });

    return true;
  }
};
